<template>
	<v-layout row wrap class="form-step-two">
		<div class="loading" v-if="step === 2 && loading">
			<div class="sk-circle">
				<div class="sk-circle1 sk-child"></div>
				<div class="sk-circle2 sk-child"></div>
				<div class="sk-circle3 sk-child"></div>
				<div class="sk-circle4 sk-child"></div>
				<div class="sk-circle5 sk-child"></div>
				<div class="sk-circle6 sk-child"></div>
				<div class="sk-circle7 sk-child"></div>
				<div class="sk-circle8 sk-child"></div>
				<div class="sk-circle9 sk-child"></div>
				<div class="sk-circle10 sk-child"></div>
				<div class="sk-circle11 sk-child"></div>
				<div class="sk-circle12 sk-child"></div>
			</div>
		</div>
		<v-flex xs12 class="form-step-two-container" primary>
			<v-layout row wrap align-center class="form-step-two-header">
				<div class="form-step-two-top">Activa tu Tienda Online</div>
				<v-btn
					v-if="!isForm"
					class="form-btn-close"
					depressed
					flat
					icon
					@click="$emit('close-form')"
				>
					<v-icon color="newprimary">close</v-icon>
				</v-btn>
				<v-flex xs7 class="b-right">
					<v-layout pl-4>
						<img
							src="/static/images-new/logos/logo-casamarket-white-mini.svg"
							alt="logo casamarket"
							height="44"
						/>
						<span class="text-xs-left ml-3 form-step-two-subtitle white--text w-black" v-if="step === 1">Datos <br>Personales</span>
						<span class="text-xs-left ml-3 form-step-two-subtitle white--text w-black" v-else>Datos de la<br>Empresa</span>
					</v-layout>
				</v-flex>
				<v-flex xs5>
					<h2 class="white--text w-black form-step-two-title">
						Paso {{ step }}
					</h2>
				</v-flex>
			</v-layout>
		</v-flex>
		<!-- <v-flex 
			xs12 
			class="form-step-two-container"
			:class="[ isQinti ? 'back-qinti' : isLucky ? 'backL' : 'primary']">
			<v-layout row wrap align-center class="form-step-two-header">
				<v-btn
					v-if="!isForm"
					class="form-btn-close"
					depressed
					flat
					icon
					@click="$emit('close-form')"
				>
					<v-icon color="white">close</v-icon>
				</v-btn>
				<v-flex class="form-img">
					<img
						src="/static/images-new/logos/logo-banner.svg"
						alt="logo qinti"
						height="44"
						v-if="isQinti"
					/>
					<img
						src="/static/images-new/logos/logo-banner-lucky.png"
						alt="logo lucky"
						height="30"
						v-else-if="isLucky"
					/>
					<img
						src="/static/images-new/logos/logo-casamarket-orange-mini.svg"
						alt="logo casamarket"
						height="44"
						v-else
					/>
				</v-flex>
				<v-flex xs12 text-left>
					<h2 class="white--text w-black form-step-two-title">
						Regístrate y vende <br/>CON NOSOTROS
					</h2>
				</v-flex>
			</v-layout>
		</v-flex> -->
		<v-flex xs12 white>
			<form-simulator
				:code-phone="codePhone"
				:document-selected="documentSelected"
				:document-types="documentTypes"
				:document-validation="documentValidation"
				:email-validation="emailValidation"
				:form="form"
				:items="items"
				:validated="validated"
				:phone-invalid="phoneInvalid"
				:phone-message="phoneMessage"
				:validation-message="validationMessage"
				:list-plans="listPlans"
				:step="step"
				@get-data="$emit('get-data', $event)"
				@valid-phone="$emit('valid-phone')"
				@change-bill="changeBill"
				:items-departaments="itemsDepartaments"
			></form-simulator>
		</v-flex>
	</v-layout>
</template>

<script>
	import formSimulator from '@/components/simulator-new/form-simulator-new';

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	function changeBill(value) {
		this.$emit('change-bill', value);
	}

	export default {
		name: 'form-step-two',
		components: {
			formSimulator,
		},
		computed: {
			isQinti,
			isLucky,
		},
		methods: {
			changeBill,
		},
		props: {
			codePhone: String,
			documentSelected: {
				default: () => {},
				type: Object,
			},
			documentTypes: {
				default: () => [],
				type: Array,
			},
			documentValidation: {
				default: true,
				type: Boolean,
			},
			emailValidation: {
				default: false,
				type: Boolean,
			},
			form: {
				default: () => {},
				type: Object,
			},
			items: {
				default: () => [],
				type: Array,
			},
			phoneInvalid: {
				default: true,
				type: Boolean,
			},
			phoneMessage: String,
			validated: {
				default: false,
				type: Boolean,
			},
			validationMessage: String,
			listPlans: {
				default: () => [],
				type: Array,
			},
			step: Number,
			itemsDepartaments: {
				default: () => [],
				type: Array,
			},
			itemsProvinces: {
				default: () => [],
				type: Array,
			},
			loading: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-step-two {
		background-color: color(white);
		height: 91%;
		left: 17px;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: size(large27);
			letter-spacing: normal;
			line-height: normal;
			padding-top: 12px;
			text-align: center;

			@media (min-width: 936px) {
				padding-top: 0px;
			}
		}

		&-subtitle {
			font-size: 16px;
			letter-spacing: normal;
			line-height: normal;
			text-align: center;
		}
		
		&-header {
			padding: 50px 0px 20px;
			position: relative;
			height: 130px;

			@media (min-width: 936px) {
				height: 145px;
				padding: 50px 0px 30px;
			}

			.form-btn-close {
				background-color: color(white) !important;
				top: 10px;
			}

			.form-img {
				left: 15px;
				position: absolute;
				top: 12px;
			}
		}

		&-top {
			background: color(newprimary);
			color: color(white);
			font-weight: 700;
			height: 34px;
			padding: 9px 18px;
			position: absolute;
			top: 0;
			text-align: left;
			width: 100%;
		} 

		&-container {
			height: 130px;

			&:before {
				background-color: #02979b;
				content: '';
				height: 12px;
				left: 0;
				position: absolute;
				top: 125px;
				transform: skew(0deg, -1.5deg);
				width: 100%;
				z-index: 2;

				@media (min-width: 936px) {
					z-index: 0;
				}
			}

			&.back-qinti {
				&:before {
					background-color: #e4278e;
					content: '';
					height: 12px;
					left: 0;
					position: absolute;
					top: 142px;
					transform: skew(0deg, -1.5deg);
					width: 100%;
					z-index: 2;

					@media (min-width: 936px) {
						top: 140px;
						z-index: 0;
					}
				}
			}

			&.backL{
				&:before {
					background-color: map-get($colors, back-l);
					content: '';
					height: 12px;
					left: 0;
					position: absolute;
					top: 142px;
					transform: skew(0deg, -1.5deg);
					width: 100%;
					z-index: 2;

					@media (min-width: 936px) {
						top: 140px;
						z-index: 0;
					}
				}
			}
		}
	}

	.show-form {
		.form-step-two {
			height: 100%;
			left: 0px;
			top: 0px;
			width: 100%;
		}
	}

	.back-qinti {
		background-color: #e4278e;
	}

	.b-right {
		border-right: 1px solid color(white);
	}

	// Componente loading

	.loading {
		background: rgba(255, 255, 255, 0.64);
		height: 100%;
		position: absolute;
		width: 100%;
		z-index: 3;

		@media (min-width: 936px) {
			border-radius: 30px;
		}
	}

	.sk-circle {
		bottom: 0px;
		height: 40px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 40px;
	}

	.sk-circle .sk-child {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.sk-circle .sk-child:before {
		background-color: color(newprimary);
		border-radius: 100%;
		content: '';
		display: block;
		height: 28%;
		margin: -12px auto;
		width: 28%;
		-webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
				animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
	}

	.sk-circle .sk-circle2 {
		-webkit-transform: rotate(30deg);
			-ms-transform: rotate(30deg);
				transform: rotate(30deg);
	}

	.sk-circle .sk-circle3 {
		-webkit-transform: rotate(60deg);
			-ms-transform: rotate(60deg);
				transform: rotate(60deg);
	}

	.sk-circle .sk-circle4 {
		-webkit-transform: rotate(90deg);
			-ms-transform: rotate(90deg);
				transform: rotate(90deg);
	}

	.sk-circle .sk-circle5 {
		-webkit-transform: rotate(120deg);
			-ms-transform: rotate(120deg);
				transform: rotate(120deg);
	}

	.sk-circle .sk-circle6 {
		-webkit-transform: rotate(150deg);
			-ms-transform: rotate(150deg);
				transform: rotate(150deg);
	}

	.sk-circle .sk-circle7 {
		-webkit-transform: rotate(180deg);
			-ms-transform: rotate(180deg);
				transform: rotate(180deg);
	}

	.sk-circle .sk-circle8 {
		-webkit-transform: rotate(210deg);
			-ms-transform: rotate(210deg);
				transform: rotate(210deg);
	}

	.sk-circle .sk-circle9 {
		-webkit-transform: rotate(240deg);
			-ms-transform: rotate(240deg);
				transform: rotate(240deg);
	}

	.sk-circle .sk-circle10 {
		-webkit-transform: rotate(270deg);
			-ms-transform: rotate(270deg);
				transform: rotate(270deg);
	}

	.sk-circle .sk-circle11 {
		-webkit-transform: rotate(300deg);
			-ms-transform: rotate(300deg);
				transform: rotate(300deg);
	}

	.sk-circle .sk-circle12 {
		-webkit-transform: rotate(330deg);
			-ms-transform: rotate(330deg);
				transform: rotate(330deg);
	}

	.sk-circle .sk-circle2:before {
		-webkit-animation-delay: -1.1s;
				animation-delay: -1.1s;
	}

	.sk-circle .sk-circle3:before {
		-webkit-animation-delay: -1s;
				animation-delay: -1s;
	}

	.sk-circle .sk-circle4:before {
		-webkit-animation-delay: -0.9s;
				animation-delay: -0.9s;
	}

	.sk-circle .sk-circle5:before {
		-webkit-animation-delay: -0.8s;
				animation-delay: -0.8s;
	}

	.sk-circle .sk-circle6:before {
		-webkit-animation-delay: -0.7s;
				animation-delay: -0.7s;
	}

	.sk-circle .sk-circle7:before {
		-webkit-animation-delay: -0.6s;
				animation-delay: -0.6s;
	}

	.sk-circle .sk-circle8:before {
		-webkit-animation-delay: -0.5s;
				animation-delay: -0.5s;
	}

	.sk-circle .sk-circle9:before {
		-webkit-animation-delay: -0.4s;
				animation-delay: -0.4s;
	}

	.sk-circle .sk-circle10:before {
		-webkit-animation-delay: -0.3s;
				animation-delay: -0.3s;
	}

	.sk-circle .sk-circle11:before {
		-webkit-animation-delay: -0.2s;
				animation-delay: -0.2s;
	}

	.sk-circle .sk-circle12:before {
		-webkit-animation-delay: -0.1s;
				animation-delay: -0.1s;
	}

	@-webkit-keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	@keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	.sk-text {
    color: map-get($colors, white);
    font-size: 17px;
		font-weight: 700;
		position: absolute;
    top: 156px;
    width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator-new/form-step-two-new.vue